import './first_metrics/first_metrics_chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

CHARTS = CustomerVisualMode.Charts

class CustomerVisualMode.Charts.FirstMetricsForTicketsCreatedInRange extends CHARTS.FirstMetricsChartView
  @NAME: 'first_metrics'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = @_getTitle()
    description = I18n.t('customer_visual_mode.charts.first_metrics.description')
    @options = {widget, title, description, data, session, isReadOnly, isResponsive}
    super(@options)

  _renderCharts: ->
    super()
    @$el.find('.average-reply-time').append(@_averageReplyTimeView().render().el)

  _averageReplyTimeView: ->
    new CustomerVisualMode.Charts.AverageTimeChartView({
      sla: @currentData.sla.reply_time,
      compliesWithSlaCount: @currentData.sla_fulfilling_average_reply_time,
      uncompliesWithSlaCount: @currentData.sla_unfulfilling_average_reply_time,
      averageTimeInSeconds: @currentData.average_reply_time,
      translations: {
        title: I18n.t('customer_visual_mode.charts.first_metrics.average_reply_time'),
        sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
        total: I18n.t('customer_visual_mode.charts.first_metrics.total'),
        drilldownTitle: @title + ' / ' +
                        I18n.t('customer_visual_mode.charts.first_metrics.average_reply_time')
      },
      clickable: true,
      dimension: 'average_reply_time',
      metricNames: ['reply_time'],
      widgetName: @constructor.NAME,
      currentData: @currentData,
      options: @options
    })

  _getTitle: ->
    @_workCalendarStrategy(I18n.t('customer_visual_mode.charts.first_metrics.title'),
                           I18n.t('customer_visual_mode.charts.first_metrics.title_without_work_calendar'))
